<script>
  export default {
    name: 'GamePicker',

    props: {
      value: {
        required: true,
      },
    },

    data: () => ({
      selectedGame: null,

      games: [
        {
          text: 'Multiplinko',
          value: 'MP',
          img: '/images/cards/games/CAF_Multiplinko.webp?v=1',
          id: 1,
          unityGame: true,
          description: [
            'Target the multipliers to achieve the highest score',
            'Use the bump feature to change the balls direction',
            'Win the round and take home the entire prize pot',
          ],
        },
        {
          text: 'MultiMines',
          value: 'MM',
          img: '/images/cards/games/CAF_Multimines.webp?v=1',
          id: 6,
          unityGame: true,
          description: [
            'Select one square in each of the five rounds and find hidden gems',
            'Focus on the multipliers and stay clear of the mines',
            'Achieve the highest score to win the entire prize pot',
          ],
        },
        {
          text: 'MaxBlast Champs',
          value: 'MBC',
          img: '/images/cards/games/CAF_MaxBlastChamps.webp?v=1',
          id: 864,
          description: [
            'Blast into space with up to 50 players',
            'Aim to be the last astronaut to eject before the rocket crashes',
            'Ensure the win to take home the entire prize pot',
          ],
        },
        {
          text: 'Sector X',
          value: 'SX',
          img: '/images/cards/games/CAF_SectorX.webp?v=1',
          id: 867,
          description: [
            'Aim for the capsules to unlock special drops',
            'Target the mega enemies to win up to 300x your bid',
            'Defeat one of the four bosses to increase your score',
          ],
        },
        {
          text: 'Mission Amazon',
          value: 'MA',
          img: '/images/cards/games/CAF_MissionAmazon.webp?v=1',
          id: 862,
          description: [
            'Collect rare gems to increase your score',
            'Obliterate the weapon carriers to unlock special weapons',
            'Defeat the legendary bosses and win big rewards',
          ],
        },
        {
          text: 'Dragon Stone',
          value: 'DS',
          img: '/images/cards/games/CAF_DragonStone.webp?v=1',
          id: 856,
          description: [
            'Collect 8 DragonStone fragments to summon the Dragon',
            'Use special weapons for maximum damage',
            'Defeat the Dragon and win huge rewards',
          ],
        },
        {
          text: 'Scarab Plinko',
          value: 'SP',
          img: '/images/cards/games/CAF_SP.webp?v=1',
          id: 12,
          unityGame: true,
          description: [
            'Hit scarabs to apply multipliers to your score.',
            'Use the bump to the left or right to control ball direction and improve your score',
            'Win the round to claim the prize pot.',
          ],
        },
        {
          text: 'Max Blocks',
          value: 'MB',
          img: '/images/cards/games/CAF_MaxBlocks.webp?v=1',
          id: 14,
          unityGame: true,
          description: [
            'Find more treasures than your opponents and claim the prize!',
            'The numbers indicate how far away the valuable metals are.',
            'Up to 4 players can mine at the same time!',
          ],
        },
        {
          text: 'Maxplosion Royale',
          value: 'MPR',
          img: '/images/cards/games/CAF_MaxPlosionRoyale.webp?v=1',
          id: 15,
          unityGame: true,
          description: [
            'Compete in matches where the last one standing wins.',
            'Use bombs to destroy walls, trap, and eliminate opponents',
            'Collect power-ups to boost speed, bomb capacity, and blast radius.',
          ],
        },
        {
          text: '21 Duel',
          value: 'duel-21',
          img: '/images/cards/games/CAF_21Duel.webp?v=1',
          id: 16,
          unityGame: true,
          description: [
            'Stack cards to hit exactly 21 and earn big points',
            'Watch out - 3 busts and it’s game over',
            'Use wild Black Jacks to clear stacks instantly',
          ],
        },
        {
          text: 'Escape the Circle Xtreme',
          value: 'escape-the-circle-xtreme',
          img: '/images/cards/games/CAF_etc-xtreme.webp?v=1',
          id: 18,
          unityGame: true,
          description: [
            'Be the first to escape and win the pot!',
            'Strategize by choosing where to drop your ball!',
            'Compete with up to 4 players in every round!',
          ],
        },
      ],

      menuProps: {
        offsetY: true,
        contentClass: 'golden-select-menu',
        maxHeight: 'auto',
        nudgeBottom: '4px',
      },
    }),

    watch: {
      value: {
        immediate: true,
        deep: true,
        handler(value) {
          this.selectedGame = this.games.find((game) => game.value === value?.value);
        },
      },
    },

    mounted() {
      this.selectGame(this.games[0]);
    },

    methods: {
      selectGame(game) {
        this.$emit('input', game);
      },
    },
  };
</script>

<template>
  <v-select
    v-model="selectedGame"
    :items="games"
    :menu-props="menuProps"
    class="game-select"
    color="gold"
    label="Choose a Game"
    outlined
    return-object
    @change="selectGame"
  >
    <template #item="{ item }">
      <div class="select-item">
        <img :src="item.img" alt="game logo" class="game-logo" />
        <span class="game-title">{{ item.text }}</span>
      </div>
    </template>
  </v-select>
</template>

<style lang="scss" scoped>
  .game-select {
    &::v-deep {
      .v-input__slot {
        background: rgba(0, 0, 0, 0.2);
        outline: 1px solid rgba(255, 255, 255, 0.6);

        fieldset legend {
          width: unset !important;
        }

        label {
          color: white;
          top: 11px !important;
          font-weight: 500;

          &.v-label--active {
            transform: scale(1) translateY(-36px);
          }
        }

        .v-select__slot .v-select__selections .v-select__selection {
          color: white;
          padding-bottom: 3px !important;
        }
      }
    }
  }
</style>
